import React from 'react';
import './VoucherView.scss';
import {useRecoilValue} from 'recoil';
import {matrixConfigState} from '../state';

type VoucherViewProps = {
    submitCode: (event: any) => void;
    inputId: string;
};

const VoucherView = (props: VoucherViewProps): React.ReactElement => {
    const matrixConfig = useRecoilValue(matrixConfigState);
    const headingId = `${props.inputId}-headling`;
    const hintId = `${props.inputId}-hint`;

    return (
        <div id="voucher" className="container mb-4 clearfix">
            <h3 id={headingId}>
                {matrixConfig?.mode === 'normal'
                    ? 'Sie haben einen Code?'
                    : 'Du hast einen Promotioncode?'
                }
            </h3>
            {/* hidden description element for screen readers,
            since placeholder is often not read when label is present */}
            <p id={hintId} className="visually-hidden">
                Bitte Code eingeben.
            </p>
            <form onSubmit={props.submitCode}>
                <div className="d-flex m-0 justify-content-center float-lg-start w-100" id="voucher-form">
                    <input
                        type="text"
                        className="form-control w-100"
                        name="code"
                        id={props.inputId}
                        aria-labelledby={headingId}
                        aria-describedby={hintId}
                        placeholder="Bitte Code eingeben"
                    />
                    <div className="p-0 m-0">
                        <button
                            type="submit"
                            className="voucher-button btn btn-primary h-100 m-0"
                            aria-label="Bitte Code bestätigen"
                        >
                            &gt;
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default VoucherView;
